<template>
  <div>
    <b-modal
      id="modal-scrollable"
      v-model="$store.state.someVariables.showNewValorFijo"
      scrollable
      no-close-on-backdrop
      title="Nuevo Valor Fijo "
      cancel-variant="outline-secondary"
    >
      <b-row class="mt-1">
        <b-col md="12" class="mt-1">
          <div class="form-label-group">
            <b-form-input
              id="floating-detalle"
              placeholder="Detalle.  (Ejemplo Arbitraje)"
              v-model="valorFijo.descripcion"
            />
            <label for="floating-auto-height">Detalle</label>
          </div>
        </b-col>

        <b-col md="5" class="mt-1">
          <div class="form-label-group">
            <b-form-input
              id="floating-valor"
              type="number"
              placeholder="Valor"
              v-model="valorFijo.valor"
            />
            <label for="floating-valor">Valor(Opcional)</label>
          </div>
        </b-col>
      </b-row>
      <br />
      <template #modal-footer>
        <div class="w-100">
          <b-row>
            <b-col class="mt-1">
              <template v-if="!showLoading">
                <b-button
                  v-if="
                    USER().rol === `${ROLES.ADMIN}` ||
                      USER().rol === `${ROLES.SUPER}` ||
                      USER().rol === ROLES.TESORERIA ||
                      USER().rol === ROLES.TECNICA
                  "
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="float-right"
                  @click="insertNuevoMotivoReglamento()"
                >
                  <span>Guardar</span>
                </b-button>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-primary"
                  class="float-right mr-1"
                  @click="onlyClose"
                >
                  Cancelar
                </b-button>
              </template>
              <div v-if="showLoading" class="text-center mt-1">
                <b-spinner variant="primary" label="Text Centered" />
              </div>
            </b-col>
          </b-row>
          <b-alert
            :show="dismissCountDown"
            v-height-fade.appear
            :variant="variante"
            style="position:absolute; bottom:55px;  width:92%; margin-left:-4px"
            @dismiss-count-down="countDownChanged"
          >
            <div
              :class="{
                'alert-body danger': variante == 'danger',
                'alert-body success': variante == 'success',
              }"
            >
              {{ messageError }}
            </div>
          </b-alert>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import {
  BRow,
  BCol,
  BFormInput,
  // BBadge,
  BButton,
  // BFormTextarea,
  // BFormSpinbutton,
  BSpinner,
  BAlert,
  // BFormRadio,
  // BFormCheckbox,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'
import store from '@/store'
import {
  URL,
  USER,
  ROLES,
  // xxx,
} from '../../utils/variables'
import apiCall from '../../utils/apiCall'

export default {
  components: {
    BRow,
    BCol,
    // BBadge,
    BButton,
    BFormInput,
    // BFormTextarea,
    // BFormSpinbutton,
    BSpinner,
    BAlert,
    // BFormRadio,
    // BFormCheckbox,
  },
  // props: {
  //   dataPartido: Object,
  //   idEquipo: String,
  // },
  props: {
    valorFijo: Object,
    categoria: String,
  },
  directives: {
    Ripple,
    // 'b-tooltip': VBTooltip,
    heightFade,
  },
  setup(props, { emit }) {
    const cantidad = ref(null)
    const valorUnitario = ref(null)
    const valorTotal = ref(0.0)
    const concepto = ref(null)
    const showLoading = ref(false)
    const messageError = ref(null)
    const numCuotas = ref(null)
    const dismissCountDown = ref(0)
    const variante = ref('danger')

    const dismissSecs = ref(3)
    const { postApi } = apiCall()
    function countDownChanged(dismissCountDownAux) {
      dismissCountDown.value = dismissCountDownAux
    }
    function showMessageAlert(type, mensaje) {
      variante.value = type
      // hasError.value = true
      messageError.value = mensaje
      dismissCountDown.value = dismissSecs.value
    }
    function focusInput(id, error) {
      document.getElementById(id).focus()
      messageError.value = error
    }

    function hasErrorForm() {
      // console.log(concepto.value)
      // console.log(props.valorFijo)
      let error = false
      if (
        props.valorFijo.descripcion === undefined ||
        props.valorFijo.descripcion === null ||
        props.valorFijo.descripcion === ''
      ) {
        error = true
        messageError.value = 'Detalle es requerido'
        focusInput('floating-detalle', 'Detalle  es requerido')
      } else if (
        props.valorFijo.valor === undefined ||
        props.valorFijo.valor === null ||
        props.valorFijo.valor === '' ||
        props.valorFijo.valor === '0'
      ) {
        error = true
        messageError.value = 'Valor es requerido'
        focusInput('floating-detalle', 'Valor  es requerido')
      } else {
        error = false
        messageError.value = ''
      }
      return error
    }
    function resetOnlyValores() {
      // messageError.value = ''
      props.valorFijo.descripcion = null
      props.valorFijo.valor = 0.0
      showLoading.value = false
      // countDownChanged(0)
    }
    function resetValores() {
      messageError.value = ''
      props.valorFijo.descripcion = null
      props.valorFijo.valor = null
      showLoading.value = false
      dismissCountDown.value = 0
      countDownChanged(0)
    }
    function onlyClose() {
      resetValores()
      store.commit('someVariables/UPDATE_SHOW_NEW_MOTIVO', false)
    }
    async function insertNuevoMotivoReglamento() {
      // const data = {
      //   articulo: props.valorFijo.motivo,
      //   valor: props.valorFijo.valor,
      //   detalle: props.valorFijo.detalle,
      // }
      const hasError = hasErrorForm()
      if (!hasError) {
        showLoading.value = true
        const path = 'ApiConfiguration/insertValorFijo'
        props.valorFijo.id_categoria = props.categoria
        const response = await postApi(URL, path, props.valorFijo)
        // console.log(response)
        if (response.flag === 'si') {
          emit('fijoAgregado', response.respuesta)
          store.commit('someVariables/UPDATE_SHOW_NEW_VALOR_FIJO', false)
          showMessageAlert('success', 'Agregado exitosamente')
          resetOnlyValores()
          // onlyClose()
        } else {
          showMessageAlert('danger', response.mensaje)
          variante.value = 'danger'
          dismissCountDown.value = dismissSecs.value
        }
        showLoading.value = false
      } else {
        showMessageAlert('danger', messageError.value)
      }
    }
    return {
      insertNuevoMotivoReglamento,
      concepto,
      cantidad,
      valorUnitario,
      showLoading,
      valorTotal,
      messageError,
      numCuotas,
      resetValores,
      onlyClose,
      countDownChanged,
      dismissCountDown,
      dismissSecs,
      USER,
      ROLES,
      variante,
    }
  },
}
</script>
